import React from 'react';
import { motion } from 'framer-motion';
export function SolutionReveal() {
  return <section className="py-24 px-4 md:px-8 bg-gradient-to-b from-cream to-rose/40" data-id="element-155">
      <div className="max-w-4xl mx-auto text-center" data-id="element-156">
        <motion.span initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-coral font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-157">
          LA SOLUCIÓN
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-5xl font-serif font-bold text-brown-deep mb-6" data-id="element-158">
          Presentamos el Kit Vientre Plano 21D
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl text-brown-medium mb-12 max-w-2xl mx-auto" data-id="element-159">
          Una faja térmica de alta densidad diseñada para durar, acompañada de
          nuestro exclusivo Protocolo Digital de Activación Linfática.
        </motion.p>

        {/* Product Showcase Placeholder */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative w-full max-w-3xl mx-auto aspect-video rounded-3xl shadow-2xl border border-white/50 overflow-hidden mb-12" data-id="element-160">
          <img src="https://cdn.magicpatterns.com/uploads/5Xi6dhnZ3kFkRNDwkcmitn/f01.png" alt="Kit Vientre Plano 21D - Resultados reales" className="w-full h-full object-cover" data-id="element-161" />
        </motion.div>

        {/* Social Proof */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="flex flex-col items-center gap-4" data-id="element-162">
          <div className="flex -space-x-3" data-id="element-163">
            {[1, 2, 3, 4, 5].map(i => <div key={i} className="w-10 h-10 rounded-full border-2 border-white bg-gray-200 flex items-center justify-center text-xs font-bold text-gray-500 overflow-hidden" data-id="element-164">
                <div className={`w-full h-full bg-gradient-to-br ${i % 2 === 0 ? 'from-rose-200 to-rose-300' : 'from-cream to-gold/30'}`} data-id="element-165"></div>
              </div>)}
          </div>
          <p className="text-sm font-medium text-brown-medium" data-id="element-166">
            + de 3.000 mujeres ya lo probaron en Argentina
          </p>
        </motion.div>
      </div>
    </section>;
}